import { Signaling } from "signaling";

export class UserSignaling implements Signaling {

	constructor(
		private webremote:any,
		private listener
	) {
		webremote.userEvents.on('webrtc', (msg) => {
			this.onMessage(msg);
		});
	}

    onMessage(msg: any) {
        this.listener(msg);
    }

    send(message) {
        this.webremote.userEvents.trigger('webrtc', message);
    }
}